import { isWeb } from '@/common/device-info';
import { delay } from '@/utils/delay';
import { useResume } from '@kibt/krn-utils';
import { useRef } from 'react';

export function useLockBuyBtn() {
    const lockRef = useRef(false);
    async function setLock(value: boolean) {
        if (isWeb) return;
        lockRef.current = value;
        if (value) {
            await delay(1500);
            console.log('lock:::1500ms后');
            lockRef.current = false;
        }
    }
    useResume(() => {
        setLock(false);
    });
    return {
        lockRef,
        setLock,
    };
}
